import { HttpClient } from '@angular/common/http'
import { inject } from '@angular/core'

import { provideNgIconLoader, withCaching } from '@ng-icons/core'

/**
 * Provides an initializer function for loading SVG icons dynamically.
 *
 * This function sets up an Angular icon loader that fetches SVG icons
 * from the `/assets/icons/` directory based on the provided icon name.
 * It uses the `HttpClient` service to perform HTTP GET requests to retrieve
 * the SVG content as plain text. Additionally, caching is enabled for
 * optimized performance.
 *
 * @returns A function that initializes the icon loader with caching support.
 */
export const provideIconsInitializer = () => {
  return provideNgIconLoader((name) => {
    const http = inject(HttpClient)
    return http.get(`/assets/yoshu-lib/icons/${name}.svg`, { responseType: 'text' })
  }, withCaching())
}
